import { render, staticRenderFns } from "./filteringComponent.vue?vue&type=template&id=1b6a513d"
import script from "./filteringComponent.vue?vue&type=script&lang=js"
export * from "./filteringComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports